import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import { French } from "flatpickr/dist/l10n/fr.js"
import { english } from "flatpickr/dist/l10n/default.js"
import { Italian } from "flatpickr/dist/l10n/it.js"

const locales = { fr: French, en: english, it: Italian }

// Les valeurs pré-remplies côté serveur arrivent sous plusieurs formes selon la
// vue : "31/12/2025" (saisie utilisateur), "31.12.2025" (ancien strftime) ou
// "2025-12-31" (Date sérialisée par Rails). On les accepte toutes pour ne jamais
// vider un champ filtré, et on ré-affiche systématiquement en d/m/Y.
function parseDate(value) {
  if (!value) return undefined

  const str = String(value).trim()
  let match

  if ((match = str.match(/^(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})/))) {
    return new Date(+match[3], +match[2] - 1, +match[1])
  }

  if ((match = str.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/))) {
    return new Date(+match[1], +match[2] - 1, +match[3])
  }

  const fallback = new Date(str)
  return isNaN(fallback.getTime()) ? undefined : fallback
}

export default class extends Controller {
  connect() {
    if (this.element._flatpickr) {
      this.element._flatpickr.destroy()
    }

    const lang = document.documentElement.lang || "fr"
    flatpickr(this.element, {
      dateFormat: "d/m/Y",
      locale: locales[lang] || French,
      allowInput: true,
      clickOpens: true,
      parseDate,
    })
  }

  disconnect() {
    if (this.element._flatpickr) {
      this.element._flatpickr.destroy()
    }
  }
}
